import axios from "axios";
import { API_URL } from '../../config/runtimeConfig';
import { addAgenceFailure, addAgenceStart, addAgenceSuccess, getAgencesByWilayaSuccess, getAgencesFailure, getAgencesStart, getAgencesSuccess, updateAgenceFailure, updateAgenceStart, updateAgenceSuccess } from "./AgenceActions";


const axiosInstance = axios.create({
    baseURL: API_URL,
});

export const getAgences = async(dispatch, pageSize, page, idWilaya, idCommune, nom)=>{
    let agenceFilter = {wilaya: idWilaya, commune: idCommune, nom: nom};
    dispatch(getAgencesStart());
    try{
        const res = await axiosInstance.post(`/admin/agences?pageSize=${pageSize}&page=${page}`,agenceFilter,{
            headers : {
                token : `nweadmin ` + JSON.parse(localStorage.getItem('user')).accessToken
            }
        });
        dispatch(getAgencesSuccess(res.data));
    }catch(err){
        if(err.response){
            dispatch(getAgencesFailure(err.response.data.message))
        }else{
            dispatch(getAgencesFailure("Unkown Error"))
        }
    }
}

export const addAgence = async(dispatch, nom, idWilaya, idCommune)=>{
    let agence = {nom: nom, wilaya: idWilaya, commune: idCommune};
    dispatch(addAgenceStart())
    try{
        const res = await axiosInstance.post(`/admin/agences/add`,agence,{
            headers : {
                token : `nweadmin ` + JSON.parse(localStorage.getItem('user')).accessToken
            }
        });
        dispatch(addAgenceSuccess(res.data));
    }catch(err){
        if(err.response){
            dispatch(addAgenceFailure(err.response.data.message))
        }else{
            dispatch(addAgenceFailure("Unkown Error"))
        }
    }
}

export const updateAgence = async(dispatch, id, nom, idWilaya, idCommune)=>{
    let agence = {nom: nom, wilaya: idWilaya, commune: idCommune};
    dispatch(updateAgenceStart())
    try{
        const res = await axiosInstance.put(`/admin/agences/update/${id}`,agence,{
            headers : {
                token : `nweadmin ` + JSON.parse(localStorage.getItem('user')).accessToken
            }
        });
        dispatch(updateAgenceSuccess(res.data));
    }catch(err){
        if(err.response){
            dispatch(updateAgenceFailure(err.response.data.message))
        }else{
            dispatch(updateAgenceFailure("Unkown Error"))
        }
    }
}

export const getAgencesByWilaya = async(dispatch)=>{
    try{
        const res = await axiosInstance.get(`/admin/agences`,{
            headers : {
                token : `nweadmin ` + JSON.parse(localStorage.getItem('user')).accessToken
            }
        });
        dispatch(getAgencesByWilayaSuccess(res.data));
    }catch(err){
        if(err.response){
            console.log(err.response.data.message);
        }else{
            console.log("Unkown Error");
        }
    }
}